import "@arco-design/web-react/es/Dropdown/style";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import _IconTag from "@arco-design/web-react/icon/react-icon/IconTag";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import "@arco-design/web-react/es/Grid/style";
import _Grid from "@arco-design/web-react/es/Grid";
import React, { useState, useRef, useMemo, useContext, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import useRoute from '@/routes';
const Row = _Grid.Row;
const Col = _Grid.Col;
import { useSelector, useDispatch } from 'react-redux';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import Logo from '@/assets/logo.svg';
import IconButton from './IconButton';
import Settings from '../Settings';
import styles from './style/index.module.less';
import defaultLocale from '@/locale';
import useStorage from '@/utils/useStorage';
import { generatePermission } from '@/routes';
import getUrlParams from '@/utils/getUrlParams';
import qs from 'query-string';
import { isArray } from '@/utils/is';
import lazyload from '@/utils/lazyload';
import NProgress from 'nprogress';
const MenuItem = _Menu.Item;
const SubMenu = _Menu.SubMenu;

function Navbar({
  show
}) {
  const t = useLocale();
  const userInfo = useSelector(state => state.userInfo);
  const dispatch = useDispatch();
  const [_, setUserStatus] = useStorage('userStatus');
  const [role, setRole] = useStorage('userRole', 'admin');
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);
  const urlParams = getUrlParams();
  const locale = useLocale();
  const history = useHistory();
  const pathname = history.location.pathname;
  const currentComponent = qs.parseUrl(pathname).url.slice(1);
  const [routes, defaultRoute] = useRoute(userInfo?.permissions);
  const defaultSelectedKeys = [currentComponent || defaultRoute];
  const paths = (currentComponent || defaultRoute).split('/');
  const defaultOpenKeys = paths.slice(0, paths.length - 1);
  const [selectedKeys, setSelectedKeys] = useState(defaultSelectedKeys);
  const [openKeys, setOpenKeys] = useState(defaultOpenKeys);
  const routeMap = useRef(new Map());
  const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes]);

  function getIconFromKey(key) {
    switch (key) {
      case 'dashboard':
        return /*#__PURE__*/React.createElement(_IconDashboard, {
          className: styles.icon
        });

      case 'example':
        return /*#__PURE__*/React.createElement(_IconTag, {
          className: styles.icon
        });

      default:
        return /*#__PURE__*/React.createElement("div", {
          className: styles['icon-empty']
        });
    }
  }

  function getFlattenRoutes(routes) {
    const res = [];

    function travel(_routes) {
      _routes.forEach(route => {
        if (route.key && !route.children) {
          route.component = lazyload(() => import(`@/pages/${route.key}`));
          res.push(route);
        } else if (isArray(route.children) && route.children.length) {
          travel(route.children);
        }
      });
    }

    travel(routes);
    return res;
  }

  function renderRoutes(locale) {
    const nodes = [];
    routeMap.current.clear();

    function travel(_routes, level, parentNode = []) {
      return _routes.map(route => {
        const {
          breadcrumb = true
        } = route;
        const iconDom = getIconFromKey(route.key);
        const titleDom = /*#__PURE__*/React.createElement(React.Fragment, null, locale[route.name] || route.name);
        console.log(route); // nodes.push(
        //   <MenuItem key={route.key}>{titleDom}</MenuItem>
        // );
        // routeMap.current.set(
        //   `/${route.key}`,
        //   breadcrumb ? [...parentNode, route.name] : []
        // );
        // if (route.key == 'home') {
        //     nodes.push(
        //       <MenuItem key={route.key}>
        //         <Link to={`/${route.key}`}>{titleDom}</Link>
        //       </MenuItem>
        //     );
        // }
        // if (route.name == 'Archive') {
        //   nodes.push(
        //     <MenuItem key={route.key}>
        //         <Link to={`/${route.key}`}>{titleDom}</Link>
        //       </MenuItem>
        //   );
        // }
        // if (route.key == 'example') {
        //   nodes.push(
        //     <MenuItem key={route.key}>
        //       <Link to={`/${route.key}`}>{titleDom}</Link>
        //     </MenuItem>
        //   );
        // }

        if (route.component && (!isArray(route.children) || isArray(route.children) && !route.children.length)) {
          routeMap.current.set(`/${route.key}`, breadcrumb ? [...parentNode, route.name] : []);

          if (level > 1) {
            return /*#__PURE__*/React.createElement(MenuItem, {
              key: route.key
            }, titleDom);
          }

          nodes.push( /*#__PURE__*/React.createElement(MenuItem, {
            key: route.key
          }, /*#__PURE__*/React.createElement(Link, {
            to: `/${route.key}`
          }, titleDom)));
        }

        if (isArray(route.children) && route.children.length) {
          const parentNode = [];

          if (iconDom.props.isIcon) {
            parentNode.push(iconDom);
          }

          if (level > 1) {
            return /*#__PURE__*/React.createElement(SubMenu, {
              key: route.key,
              title: titleDom
            }, travel(route.children, level + 1, [...parentNode, route.name]));
          }

          nodes.push( /*#__PURE__*/React.createElement(SubMenu, {
            key: route.key,
            title: titleDom
          }, travel(route.children, level + 1, [...parentNode, route.name])));
        }
      });
    }

    travel(routes, 1);
    return nodes;
  }

  function onClickMenuItem(key) {
    const currentRoute = flattenRoutes.find(r => r.key === key);
    const component = currentRoute.component;
    const preload = component.preload();
    NProgress.start();
    preload.then(() => {
      setSelectedKeys([key]);
      history.push(currentRoute.path ? currentRoute.path : `/${key}`);
      NProgress.done();
    });
  }

  function logout() {
    setUserStatus('logout');
    localStorage.setItem('redirectUrl', '');
    window.location.href = '/login';
  }

  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    } else {
      // Message.info(`You clicked ${key}`);
      const currentRoute = flattenRoutes.find(r => r.key === key);
      const component = currentRoute.component;
      const preload = component.preload();
      NProgress.start();
      preload.then(() => {
        setSelectedKeys([key]);
        history.push(currentRoute.path ? currentRoute.path : `/${key}`);
        NProgress.done();
      });
    }
  }

  useEffect(() => {
    dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: { ...userInfo,
          permissions: generatePermission(role)
        }
      }
    });
  }, [role]);

  if (!show) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['fixed-settings']
    }, /*#__PURE__*/React.createElement(Settings, {
      trigger: /*#__PURE__*/React.createElement(_Button, {
        icon: /*#__PURE__*/React.createElement(_IconSettings, null),
        type: "primary",
        size: "large"
      })
    }));
  }

  const handleChangeRole = () => {
    const newRole = role === 'admin' ? 'user' : 'admin';
    setRole(newRole);
  };

  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    key: "role",
    onClickMenuItem: onMenuItemClick
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "info"
  }, /*#__PURE__*/React.createElement(_IconUser, {
    className: styles['dropdown-icon']
  }), t['menu.user.setting']), /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: '4px 0'
    }
  }), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_IconPoweroff, {
    className: styles['dropdown-icon']
  }), t['navbar.logout']));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.menu
  }, /*#__PURE__*/React.createElement(_Menu, {
    mode: "horizontal",
    onClickMenuItem: onClickMenuItem,
    selectedKeys: selectedKeys,
    openKeys: openKeys // onClickSubMenu={(_, openKeys) => setOpenKeys(openKeys)}

  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "home"
  }, locale['home']), /*#__PURE__*/React.createElement(MenuItem, {
    key: "pro"
  }, locale['pro']), /*#__PURE__*/React.createElement(MenuItem, {
    key: "tv"
  }, locale['tv']), /*#__PURE__*/React.createElement(MenuItem, {
    key: "app"
  }, locale['app']), /*#__PURE__*/React.createElement(MenuItem, {
    key: "standings"
  }, locale['standings']), /*#__PURE__*/React.createElement(MenuItem, {
    key: "about"
  }, locale['about'])))), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Select, {
    triggerElement: /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconLanguage, null)
    }),
    options: [{
      label: '中文',
      value: 'zh-CN'
    }, {
      label: 'English',
      value: 'en-US'
    }],
    value: lang,
    triggerProps: {
      autoAlignPopupWidth: false,
      autoAlignPopupMinWidth: true,
      position: 'br'
    },
    trigger: "hover",
    onChange: value => {
      setLang(value);
      const nextLang = defaultLocale[value];

      _Message.info(`${nextLang['message.lang.tips']}${value}`);
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Tooltip, {
    content: theme === 'light' ? t['settings.navbar.theme.toDark'] : t['settings.navbar.theme.toLight']
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
    onClick: () => setTheme(theme === 'light' ? 'dark' : 'light')
  }))), userInfo && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Dropdown, {
    droplist: droplist,
    position: "br"
  }, /*#__PURE__*/React.createElement(_Avatar, {
    size: 32,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(_IconUser, null))))));
}

export default Navbar;